export const paymentStatus = {
  ACCEPTED: 'ACCEPTED',
  UNACCEPTED: 'UNACCEPTED',
  WAITING: 'WAITING',
}
